// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudServerOutlinedSvg from "@fishx/icons-svg/es/asn/CloudServerOutlined";
import FishxIcon from '../components/FishxIcon';

var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudServerOutlinedSvg
  }));
};

CloudServerOutlined.displayName = 'CloudServerOutlined';
export default React.forwardRef(CloudServerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudServerOutlined.js
// module id = 2249
// module chunks = 0